let interval = null;
let originalTitle = document.title;

export const startTabAlert = (message = "Nueva alerta", count = 1) => {
  let alertCount = count;
  if (interval) {
    clearInterval(interval);
    interval = null;
  }

  interval = setInterval(() => {
    document.title =
      document.title === originalTitle
        ? count === 1
          ? `🔔 ${message}`
          : `🔔 ${alertCount} Nuevas alertas`
        : originalTitle;
  }, 1000);
};

export const stopTabAlert = () => {
  if (interval) {
    clearInterval(interval);
    interval = null;
  }

  document.title = originalTitle;
};
